import { useGateValue } from '@statsig/react-bindings';

export enum LogiblocksGate {
  AI_BUILDER = 'logiblocks_ai_builder',
  DELAY_UNTIL_EVENT = 'logiblocks_delay_until_event',
  TEST_RUNS = 'logiblocks_test_runs',
}

export function resolveLogiblocksGateEnabled(
  statsigEnabled: boolean,
  isDevelopment: boolean
): boolean {
  return isDevelopment || statsigEnabled;
}

export function useLogiblocksGateEnabled(gate: LogiblocksGate): boolean {
  const statsigEnabled = useGateValue(gate);
  return resolveLogiblocksGateEnabled(
    statsigEnabled,
    import.meta.env.DEV && import.meta.env.MODE !== 'test'
  );
}
